module.exports = __webpack_public_path__ + "img/bul_component_header.08d7c1c8.svg";